import "./App.css";
import Allpages from "./pages/Allpages/Allpages";

function App() {
  return (
    <div className="bg-bg relative">
      <Allpages />
    </div>
  );
}

export default App;
